import { useEffect } from 'react';
import { CANONICAL_ORIGIN } from '../hoc/SEOUpdater';

const Structured404 = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.innerHTML = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '404 Page Not Found',
      description: "The requested page could not be found on Avagyan Law Firm's website.",
      // Fixed origin, not window.location.href - see SEOUpdater.jsx for why
      // (multiple reachable hosts, and react-snap runs against localhost).
      url: `${CANONICAL_ORIGIN}${window.location.pathname}`,
      isPartOf: {
        '@type': 'WebSite',
        name: 'Avagyan Law Firm',
        url: CANONICAL_ORIGIN,
      },
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default Structured404;
